/*!
 * ASW Distillery - Big Thirst Storefront Loader
 *
 * Install this file once on the client site. It deliberately fetches the
 * config with a fresh query string because Shopify Files are long cached.
 */

(function () {
  'use strict';

  if (window.__BT_ASW_LOADER_LOADED) return;
  window.__BT_ASW_LOADER_LOADED = true;

  var DEFAULT_CONFIG_SRC = 'https://z0qbxp-p0.myshopify.com/cdn/shop/files/asw-storefront-config.js';
  var configSrc = window.__BT_ASW_CONFIG_SRC || DEFAULT_CONFIG_SRC;
  var configVersion = window.__BT_ASW_CONFIG_VERSION || String(Date.now());
  var separator = configSrc.indexOf('?') === -1 ? '?' : '&';
  var head = document.head || document.documentElement;
  var script = document.createElement('script');

  script.src = configSrc + separator + 'v=' + encodeURIComponent(configVersion);
  script.async = false;
  script.setAttribute('data-bt-asw-config', 'true');
  head.appendChild(script);
})();
